// Runs once at app boot: if the URL carries `?masquerade_exchange=<token>`,
// redeem it for a real bearer token, stash it in localStorage under the same
// key `authStore` uses, then scrub the query string from the URL so the token
// never appears in history or referrer headers past the first frame.
//
// Any failure (expired / already-used / network) is swallowed and the URL is
// still scrubbed — the user lands unauthenticated on the SPA and the existing
// auth redirect kicks in as usual.
export async function bootstrapMasqueradeExchange() {
  if (globalThis.window === undefined) return

  const params = new URLSearchParams(location.search)
  const exchangeToken = params.get('masquerade_exchange')
  if (!exchangeToken) return

  try {
    const response = await fetch('/api/v1/auth/masquerade_exchange', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ exchange_token: exchangeToken }),
    })

    if (response.ok) {
      const data = await response.json()
      if (data?.access_token) {
        localStorage.setItem('token', data.access_token)
      }
    }
  } catch {
    // Swallow — scrub URL below and let the normal auth flow handle it.
  } finally {
    params.delete('masquerade_exchange')
    const qs = params.toString()
    const scrubbed = location.pathname + (qs ? `?${qs}` : '') + location.hash
    history.replaceState(history.state, '', scrubbed)
  }
}
